import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LocationPickerPopup from "./component";
import { toggleLocationPicker, setLocationSelectionType, updateUserLocation } from "./actions";
import { setPosition, fetchGeoDetails, resetError } from "../../location/actions";
import { updateNearestBranchSearchKey, setSelectionType } from "../nearest-branch/actions";
import { selectCity, setCityAvailability } from "../cities/actions";
import { setComingSoon, clearAllFilters, reloadCarList, setShowManualPincodePopup, updateSortOrder } from "../car-list/actions";
import { updatePincodeSSRStatus } from "../../buy-car-pincode-config/actions";
import { setIsIndiaPage } from "../../filters/actions";
import { resetFilters, fetchFilters } from "../filter-v2/action";
import { setShowPopularCitiesOnHomepage } from "../buy-used-car/actions";
import {getServiceabilityCheck, fetchNearByCarsList, setIsServiceableLoading, updateSSRStatus} from "../nearby-cities/actions";
import {updateStatsigConfig, updateStatsigTimeStamp} from "../../shared/ab-experiment/actions";

const mapStateToProps = ({
    locationPicker: { showLocationPicker, locationSelectionType, pageType },
    nearbyCities: { isServiceable, isSSrServiceable, isNearByCityAvailable  },
    location: { pincode, error, cityInfo },
    config: { cityList },
    buyCarPincodeConfig: {
        isSSR: isBuyCarPincodeConfigSSR,
        data: pincodeConfigData,
        isPincodeSSR
    },
    cities: { selectedCity, isCityUnavailable },
    filters: {
        isIndiaPage
    },
    carList: {
        appliedOptions,
        error: carListError,
        showManualPincodePopup
    },
    user: {
        gaId,
        preApproved,
        preApprovalScreenVariant
    },
    consumerFinance: {
        cfStatus,
        selectedOffer,
        userId
    }
}) => {
    const { city_id: cityID } = cityInfo || {};
    return {
        showLocationPicker,
        cityList,
        pincode,
        error,
        isBuyCarPincodeConfigSSR,
        pincodeConfigData,
        locationSelectionType,
        selectedCity,
        cityID,
        isPincodeSSR,
        pageType,
        isCityUnavailable,
        isIndiaPage,
        appliedOptions,
        gaId,
        isServiceable,
        selectedOffer,
        preApproved,
        preApprovalScreenVariant,
        creditStatus: cfStatus,
        userId,
        isSSrServiceable,
        isNearByCityAvailable,
        carListError,
        showManualPincodePopup

    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    toggleLocationPickerConnect: toggleLocationPicker,
    fetchGeoDetailsConnect: fetchGeoDetails,
    setPositionConnect: setPosition,
    updateNearestBranchSearchKeyConnect: updateNearestBranchSearchKey,
    setSelectionTypeConnect: setSelectionType,
    selectCityConnect: selectCity,
    resetErrorConnect: resetError,
    setLocationSelectionTypeConnect: setLocationSelectionType,
    setComingSoonConnect: setComingSoon,
    updatePincodeSSRStatusConnect: updatePincodeSSRStatus,
    setCityAvailabilityConnect: setCityAvailability,
    setIsIndiaPageConnect: setIsIndiaPage,
    clearAllFiltersConnect: clearAllFilters,
    reloadCarListConnect: reloadCarList,
    resetFiltersConnect: resetFilters,
    fetchFiltersConnect: fetchFilters,
    setShowPopularCitiesOnHomepageConnect: setShowPopularCitiesOnHomepage,
    getServiceabilityCheckConnect: getServiceabilityCheck,
    fetchNearByCarsListConnect: fetchNearByCarsList,
    setIsServiceableLoadingConnect: setIsServiceableLoading,
    updateSSRStatusConnect: updateSSRStatus,
    setShowManualPincodePopupConnect: setShowManualPincodePopup,
    updateStatsigConfigConnect: updateStatsigConfig,
    updateUserLocationConnect: updateUserLocation,
    updateStatsigTimeStampConnect: updateStatsigTimeStamp,
    updateSortOrderConnect: updateSortOrder
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LocationPickerPopup);

